import NotFoundPage from "./../../views/others/404";
import NoPrivilege from "./../../views/others/no-privilege";

export const otherRouters = [
  {
    path: "/404",
    name: "404",
    component: NotFoundPage,
    meta: {
      breadcrumb: [],
      privilegeCode: ""
    }
  },
  {
    path: "/noPrivilege",
    name: "noPrivilege",
    component: NoPrivilege,
    meta: {
      breadcrumb: [],
      privilegeCode: ""
    }
  }
];
